<template>
	<xl-tooltip :content="content" placement="top">
		<div class="model-icon">
			<div class="tooth-num" v-if="toothNum && isJaw">{{ toothNum }}</div>
			<xl-image :src="modelIconList(type)" object="contain"></xl-image>
		</div>
	</xl-tooltip>
</template>
<script setup>
import { computed } from 'vue';
import { XlTooltip, XlImage } from '@shining3d/ui-components';

import { useLang } from '@shining3d/common-module/utils/lang';

import smileFace from '../../assets/image/smileFace.svg';
import otherJaw from '../../assets/image/otherJaw.svg';
import abutmentLowerJaw from '../../assets/image/abutmentLowerJaw.svg';
import abutmentUpperJaw from '../../assets/image/abutmentUpperJaw.svg';
import copyDentureLowerJaw from '../../assets/image/copyDentureLowerJaw.svg';
import copyDentureUpperJaw from '../../assets/image/copyDentureUpperJaw.svg';
import faceLowerJaw from '../../assets/image/faceLowerJaw.svg';
import faceUpperJaw from '../../assets/image/faceUpperJaw.svg';
import impressionLowerJaw from '../../assets/image/impressionLowerJaw.svg';
import impressionUpperJaw from '../../assets/image/impressionUpperJaw.svg';
import lowerJaw from '../../assets/image/lowerJaw.svg';
import lowerJawAestheticplate from '../../assets/image/lowerJawAestheticplate.svg';
import lowerJawNum from '../../assets/image/lowerJawNum.svg';
import lowerJawPerOp from '../../assets/image/lowerJawPerOp.svg';
import lowerJawScanbody from '../../assets/image/lowerJawScanbody.svg';
import scanBodyLowerJaw from '../../assets/image/scanBodyLowerJaw.svg';
import scanBodyMark from '../../assets/image/scanBodyMark.svg';
import scanBodyReplace from '../../assets/image/scanBodyReplace.svg';
import scanBodyUpperJaw from '../../assets/image/scanBodyUpperJaw.svg';
import totalJaw1 from '../../assets/image/totalJaw1.svg';
import totalJaw2 from '../../assets/image/totalJaw2.svg';
import totalJawAestheticplate from '../../assets/image/totalJawAestheticplate.svg';
import totallJaw3 from '../../assets/image/totallJaw3.svg';
import upperJaw from '../../assets/image/upperJaw.svg';
import upperJawAestheticplate from '../../assets/image/upperJawAestheticplate.svg';
import upperJawNum from '../../assets/image/upperJawNum.svg';
import upperJawPerOp from '../../assets/image/upperJawPerOp.svg';
import upperJawScanbody from '../../assets/image/upperJawScanbody.svg';
import td_model_lowerJaw from '../../assets/image/3d_model_lowerJaw.svg';
import td_model_upperJaw from '../../assets/image/3d_model_upperJaw.svg';
import night_guard_lowerJaw from '../../assets/image/night_guard_lowerJaw.svg';
import night_guard_upperJaw from '../../assets/image/night_guard_upperJaw.svg';
import single_crown_lowerJaw from '../../assets/image/single_crown_lowerJaw.svg';
import single_crown_upperJaw from '../../assets/image/single_crown_upperJaw.svg';
import splint_lowerJaw from '../../assets/image/splint_lowerJaw.svg';
import splint_upperJaw from '../../assets/image/splint_upperJaw.svg';


import { ClassTypes } from '../../common/orderConst';
const { $t: $txdo } = useLang( '@shining3d/xl-design-order' );

const props = defineProps({
	type: { type: String },
	toothNum: { type: [String, Number] },
	modelTips: {
		type: String
	},
	classType: String,
	resultType: String
});
// 上下颌且有toothNum时展示带牙号icon
const isJaw = computed(() => ['upperJaw', 'lowerJaw'].includes(props.type));

const content = computed(() => (props.modelTips || $txdo( 'design.model.defaultJaw' )) + ((props.toothNum && isJaw.value) ? `-${$txdo( 'design.model.toothNumber' ) + props.toothNum}` : '' ));

const imageFileList = {
	smileFace,
	otherJaw,
	abutmentLowerJaw,
	abutmentUpperJaw,
	copyDentureLowerJaw,
	copyDentureUpperJaw,
	faceLowerJaw,
	faceUpperJaw,
	impressionLowerJaw,
	impressionUpperJaw,
	lowerJaw,
	lowerJawAestheticplate,
	lowerJawNum,
	lowerJawPerOp,
	lowerJawScanbody,
	scanBodyLowerJaw,
	scanBodyMark,
	scanBodyReplace,
	scanBodyUpperJaw,
	totalJaw1,
	totalJaw2,
	totalJawAestheticplate,
	totallJaw3,
	upperJaw,
	upperJawAestheticplate,
	upperJawNum,
	upperJawPerOp,
	upperJawScanbody,
	'3d_model_lowerJaw': td_model_lowerJaw,
	'3d_model_upperJaw': td_model_upperJaw,
	night_guard_lowerJaw,
	night_guard_upperJaw,
	single_crown_lowerJaw,
	single_crown_upperJaw,
	splint_lowerJaw,
	splint_upperJaw
};

const modelIconList = () => {
	const { classType, type, resultType } = props
	let result;
	if (resultType === 'manual') {
		result = otherJaw;
	} else if (Object.values(ClassTypes).includes(classType)) {
		result = imageFileList[`${classType}_${type}`]
	} else {
		result = imageFileList[type];
	}
	if ( !result ) {
		if ( classType === 'faceScan' ) {
			result = smileFace;
		} else {
			// 默认的模型图标
			result = otherJaw;
		}
	}
	return result;
};

</script>
<style lang="scss" scoped>
.model-icon {
	height: 34px;
	position: relative;
	:deep(.xl-image) {
		width: 34px;
		height: 34px;
	}
	.tooth-num {
		position: absolute;
		right: -1px;
		top: 0px;
		font-size: 10px;
		font-weight: 700;
		color: #fff;
		width: 20px;
		text-align: center;
		z-index: 10;
	}
}
</style>
